// Central playback-speed control for the use-case scenes.
//
// Some scenes (intro-offer, membership-journey, fill-classes) read too fast to
// follow, so they play 10% slower via SCENE_SLOWDOWN. capture-leads and
// grow-locations are already well paced and intentionally do NOT use this.
//
// To test/tune speed without editing code, append `?speed=<n>` to the URL:
//   ?speed=2   -> everything (that opts in) plays at half speed
//   ?speed=0.5 -> twice as fast
// The override multiplies on top of each scene's own factor.

export const SCENE_SLOWDOWN = 1.1;

/** Inverse of SCENE_SLOWDOWN — plays a scene 10% faster (grow-locations). */
export const SCENE_SPEEDUP = 0.9;

let cachedOverride: number | null = null;

function speedOverride(): number {
  if (cachedOverride !== null) return cachedOverride;
  if (typeof window === "undefined") return 1;
  const raw = new URLSearchParams(window.location.search).get("speed");
  const n = raw ? Number(raw) : Number.NaN;
  cachedOverride = Number.isFinite(n) && n > 0 ? n : 1;
  return cachedOverride;
}

/** Scale a base delay (ms) by an optional per-scene factor and the URL override. */
export const scaleDelay = (ms: number, factor = 1) => Math.round(ms * factor * speedOverride());
